module.exports = __webpack_public_path__ + "static/img/loginLogo.43b590ad.png";